import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";
import { Substance, APIError } from "src/types";

export function useSubstances() {
  async function queryFn(): Promise<Substance[]> {
    const url = `/planning-api/substances`;
    const response = await Axios.get(url);
    return response.data;
  }
  return useQuery<Substance[], AxiosError<APIError>>(baseDataKeys.substances, () => queryFn());
}
